import { render, staticRenderFns } from "./importer.vue?vue&type=template&id=354bbc40&scoped=true"
import script from "./importer.vue?vue&type=script&lang=js"
export * from "./importer.vue?vue&type=script&lang=js"
import style0 from "./importer.vue?vue&type=style&index=0&id=354bbc40&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "354bbc40",
  null
  
)

export default component.exports